import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {SortableItemProps, ArrayItemType} from '../eca-doc-list.util';
import {ListItem, ListItemButton} from '@mui/material';

function SortableItem(props: Readonly<SortableItemProps>) {
  const {item, disabled} = props;
  const {handleToggle, selected, elementType, className} = props;
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} =
    useSortable({id: item.id, disabled});
  const {...selectedAttributes} = attributes;
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const isArrayItemType = (thing: any): thing is ArrayItemType =>
    thing.name && thing.id;

  return (
    <>
      {elementType === 'button' && isArrayItemType(item) ? (
        <ListItem disablePadding>
          <ListItemButton
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className={className}
            onClick={() => {
              if (!isDragging && handleToggle) handleToggle(item);
            }}
            selected={selected}
          >
            {props.children}
          </ListItemButton>
        </ListItem>
      ) : (
        <ListItem
          ref={setNodeRef}
          style={style}
          {...selectedAttributes}
          {...listeners}
          className={className}
          role="listitem"
        >
          {props.children}
        </ListItem>
      )}
    </>
  );
}

export default SortableItem;
